class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

onFormSubmit(event) {
  const query = this.getQuery().toLowerCase().trim();

  const directLinks = {
    'upf 50': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'upf 50+': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'uvf 50': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'uvf 50+': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'lab test': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'lab testing': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'test results': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'uv test': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'uv testing': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'does it block uv': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'do they block uv': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing',
    'how much protection': 'https://xaiyona.com/products/disposable-uv-nail-glove#lab-testing'
  };

  if (directLinks[query]) {
    event.preventDefault();
    window.location.href = directLinks[query];
    return;
  }

  if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
    event.preventDefault();
  }
}

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }
expandSearchTerm(searchTerm) {
  const term = searchTerm.toLowerCase().trim();

  const aliases = [
    // RETURNS / REFUNDS / EXCHANGES
    {
      words: [
        'money back',
        'send back',
        'return item',
        'return order',
        'return policy',
        'returns',
        'refund',
        'refunds',
        'refund policy',
        'exchange',
        'exchanges',
        'wrong item',
        'wrong product',
        'damaged item',
        'damaged product',
        'defective',
        'broken',
        'replacement'
      ],
      search: 'return'
    },

    // SHIPPING
    {
      words: [
        'shipping',
        'shipping time',
        'delivery',
        'delivery time',
        'how long does shipping take',
        'when will it arrive',
        'when will my order arrive',
        'how long will my order take',
        'processing',
        'processing time',
        'ship time',
        'ship'
      ],
      search: 'shipping'
    },

    // ORDER TRACKING
    {
      words: [
        'tracking',
        'track',
        'track order',
        'track my order',
        'track package',
        'where is my order',
        'where is my package',
        'order status',
        'package status',
        'lost package',
        'missing package',
        'package missing',
        'order missing'
      ],
      search: 'tracking'
    },

    // CANCELLATIONS / ORDER CHANGES
    {
      words: [
        'cancel',
        'cancel order',
        'cancel my order',
        'cancellation',
        'change order',
        'change my order',
        'edit order',
        'change address',
        'wrong address',
        'shipping address'
      ],
      search: 'order'
    },

    // UV GLOVES
    {
      words: [
        'uv gloves',
        'uv glove',
        'nail gloves',
        'nail glove',
        'gel gloves',
        'gel nail gloves',
        'manicure gloves',
        'manicure glove',
        'gloves for gel nails',
        'gloves for gel manicure',
        'gloves for uv light',
        'gloves for nail lamp',
        'gloves under nail lamp',
        'fingerless gloves',
        'half finger gloves',
        'disposable gloves',
        'disposable nail gloves',
        'disposable uv gloves',
        'hand protection',
        'protect my hands',
        'protect hands',
        'hand cover'
      ],
      search: 'UV gloves'
    },

    // UV / GEL-LAMP EDUCATION
    {
      words: [
        'uv',
        'uva',
        'ultraviolet',
        'uv light',
        'uv exposure',
        'uv damage',
        'uv protection',
        'uva protection',
        'nail lamp',
        'uv lamp',
        'led lamp',
        'gel lamp',
        'gel light',
        'nail light',
        'curing lamp',
        'curing light',
        'gel manicure safety',
        'are gel nails safe',
        'are gel lamps safe',
        'are nail lamps safe',
        'is uv bad',
        'uv skin damage',
        'skin damage',
        'photoaging',
        'aging hands',
        'dna damage',
        'sunscreen',
        'protect skin'
      ],
      search: 'UV protection'
    },

    // LAB TESTING / PROTECTION LEVEL
    {
      words: [
        'lab',
        'lab test',
        'lab testing',
        'tested',
        'testing',
        'test results',
        'proof',
        'uv test',
        'uv testing',
        'protection test',
        'upf',
        'upf 50',
        'upf 50+',
        'uvf',
        'uvf 50',
        'uvf 50+',
        'how much uv',
        'how much protection',
        'does it block uv',
        'do they block uv',
        'does this work'
      ],
      search: 'lab testing'
    },

    // HOW TO USE
    {
      words: [
        'how to use',
        'how do i use',
        'instructions',
        'directions',
        'how to wear',
        'put on',
        'how does it work',
        'how it works',
        'use gloves',
        'wear gloves'
      ],
      search: 'how to use'
    },

    // MATERIAL / COMFORT
    {
      words: [
        'material',
        'materials',
        'what are they made of',
        'made of',
        'fabric',
        'polyester',
        'breathable',
        'mesh',
        'sweaty',
        'lightweight',
        'comfortable',
        'touch screen',
        'touchscreen'
      ],
      search: 'material'
    },

    // DISPOSABLE / REUSE
    {
      words: [
        'disposable',
        'single use',
        'single-use',
        'reuse',
        'reusable',
        'can i reuse',
        'can you reuse',
        'one time use',
        'how many times'
      ],
      search: 'disposable'
    },

    // PACK SIZES / BULK
    {
      words: [
        'bulk',
        'wholesale',
        'packs',
        'pack',
        '10 pack',
        '25 pack',
        '50 pack',
        '100 pack',
        'salon pack',
        'nail salon',
        'nail tech',
        'nail technician',
        'professional',
        'bulk gloves'
      ],
      search: 'UV gloves'
    },

    // NAIL DECALS
    {
      words: [
        'nail decals',
        'nail decal',
        'nail stickers',
        'nail sticker',
        'anime nails',
        'anime nail decals',
        'anime nail stickers',
        'waterslide',
        'water slide',
        'waterslide decals',
        'water slide decals',
        'nail art',
        'nail designs',
        'nail accessories'
      ],
      search: 'nail decals'
    },

    // CONTACT / HELP
    {
      words: [
        'contact',
        'contact us',
        'help',
        'support',
        'customer service',
        'question',
        'questions',
        'email',
        'reach out'
      ],
      search: 'FAQ'
    }
  ];

  for (const group of aliases) {
    if (group.words.some((word) => term === word || term.includes(word))) {
      return group.search;
    }
  }

  return searchTerm;
}
  getSearchResults(searchTerm) {
  const expandedSearchTerm = this.expandSearchTerm(searchTerm);
  const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);
      searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      return;
    }

    const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(expandedSearchTerm)}&resources[type]=product,collection,page&resources[options][fields]=title,body,product_type,tag,variants.title,vendor&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);

        searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          searchDeferred?.reject(error);
          return;
        }
        searchDeferred?.reject(error);
        this.close();
        throw error;
      });
  }

  getTotalResultCount() {
    return parseInt(this.predictiveSearchResults.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
  }

  dispatchSearchUpdateEvent(query) {
    const { SearchUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent) return null;

    const deferred = SearchUpdateEvent.createPromise();
    this.dispatchEvent(
      new SearchUpdateEvent({
        search: { query },
        promise: deferred.promise,
      })
    );
    return deferred;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
